// extracted by mini-css-extract-plugin
export default {"root":"DownloadIDPage_root__oNb1i"};